import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeContextProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Heroes from './layouts/Heroes';
import HeroDetails from './components/HeroDetails';
import Home from './layouts/Home';
import About from './layouts/About';
function App() {
    return (_jsxs(ThemeContextProvider, { children: [_jsx(CssBaseline, {}), _jsx(Router, { children: _jsx(Routes, { children: _jsxs(Route, { path: "/", element: _jsx(Layout, {}), children: [_jsx(Route, { index: true, element: _jsx(Home, {}) }), _jsx(Route, { path: "about", element: _jsx(About, {}) }), _jsx(Route, { path: "heroes", element: _jsx(Heroes, {}), children: _jsx(Route, { path: ":id", element: _jsx(HeroDetails, {}) }) })] }) }) })] }));
}
export default App;
